import type {
  SchemaBuilderFieldEditorFormValues,
  SchemaBuilderFieldEditorProps,
} from "./schema-builder-field-editor.type";
import type { SchemaBuilderFieldType } from "../schema-builder-field-type";

import { Form } from "antd";

import { isNewSchemaField } from "../schema-builder.helper";

import {
  generateFormValues,
  getInitialValuesFromSchema,
  getNewSchemaFromValues,
  isFormValuesEqual,
  isSchemaFieldEditable,
} from "./schema-builder-field-editor.helper";

export const useSchemaBuilderFieldEditor = ({
  schema,
  onFieldUpdate,
}: SchemaBuilderFieldEditorProps) => {
  const [form] = Form.useForm<SchemaBuilderFieldEditorFormValues>();

  const isNewField = isNewSchemaField(schema);
  const isEditableField = isSchemaFieldEditable(schema);

  const { initialFieldType, initialValues } =
    getInitialValuesFromSchema(schema);

  const formValues = Form.useWatch([], form) ?? initialValues;
  const fieldType = formValues.fieldType ?? initialFieldType;
  const valuesAreEquals = isFormValuesEqual(initialValues, formValues);

  const onTypeChange = (fieldType: SchemaBuilderFieldType) => {
    const newValues = generateFormValues({ fieldType, schema, form });
    form.setFieldsValue(newValues);
  };

  const onFormSubmit = (values: SchemaBuilderFieldEditorFormValues) => {
    const newSchema = getNewSchemaFromValues(values);
    if (!newSchema) return; // schema update not supported (ex: severity fields)
    onFieldUpdate?.(newSchema);
  };

  return {
    schema,
    form,
    fieldType,
    initialValues,
    onTypeChange,
    onFormSubmit,
    isNewField,
    isEditableField,
    valuesAreEquals,
  };
};
